export default "__VITE_ASSET__Ckl4swOz__"